import RetainContent from './RetainContentView';

export default RetainContent;
